// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__ghIPa","active":"Nav_active__px7Tw"};